export interface SubscriptionAccessStatus {
	payment_required: boolean;
	payment_url?: string | null;
	amount_remaining?: number | null;
	currency?: string | null;
}

export function isSubscriptionPaymentRequired(body: unknown): boolean {
	const response = body as { error?: { code?: string }; detail?: { code?: string } } | null;
	return (response?.error?.code ?? response?.detail?.code) === "SUBSCRIPTION_PAYMENT_REQUIRED";
}
